import script from "./withdraw.vue?vue&type=script&setup=true&lang=js"
export * from "./withdraw.vue?vue&type=script&setup=true&lang=js"

import "./withdraw.vue?vue&type=style&index=0&id=f0ae493c&scoped=true&lang=css"

import exportComponent from "/builds/jolly88-complex/frontend/affiliate-static-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f0ae493c"]])

export default __exports__